/**
 * Downloads a document from the given link and saves it with the specified title.
 *
 * @param {string} downloadLink - The URL of the document to download.
 * @param {string} title - The title to save the document as.
 * @returns {Promise<void>} A promise that resolves when the download is complete.
 */
export function downloadDocument(
  downloadLink: string,
  title: string
): Promise<void> {
  const FILE_TYPE_JSON = 'application/json'

  return new Promise((resolve, reject) => {
    if (!downloadLink || !title) {
      reject(new Error('Invalid download link or title.'))
      return
    }

    fetch(downloadLink)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch the document.')
        }
        return response.blob()
      })
      .then((blob) => {
        const fileType = blob.type || FILE_TYPE_JSON
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = `${title}.${fileType.split('/')[1]}`
        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)
        window.URL.revokeObjectURL(url)
        resolve()
      })
      .catch((error) => {
        reject(error)
      })
  })
}
